import React from 'react';
const ThemeContext = React.createContext('theme');
export default ThemeContext;
